import { render, staticRenderFns } from "./ModalPalletDetails.vue?vue&type=template&id=49037e2c&scoped=true"
import script from "./ModalPalletDetails.vue?vue&type=script&lang=js"
export * from "./ModalPalletDetails.vue?vue&type=script&lang=js"
import style0 from "./ModalPalletDetails.vue?vue&type=style&index=0&id=49037e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49037e2c",
  null
  
)

export default component.exports